import {Component, Inject, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'mp-no-mieter-dialog',
  templateUrl: 'login-no-mieter.dialog.component.html',
  styleUrls: ['login-no-mieter.dialog.component.css']
})
export class LoginNoMieterDialogComponent implements OnInit {

  constructor(private router: Router,
              private dialogRef: MatDialogRef<LoginNoMieterDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  public cDots = Array(5).fill(0).map((x, i) => i);

  ngOnInit(): void {
  }

  close(): void {
    this.dialogRef.close();
  }

}
